import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/OrderDetail/OrderParamsCard.module.less";
const { Text } = Typography;
const ParamRow = ({ label, value }) => (_jsxs("div", { className: styles.row, children: [_jsx(Text, { type: "secondary", className: styles.label, children: label }), _jsx(Text, { className: styles.value, children: value })] }));
const OrderParamsCard = observer(() => {
    const { orderDetailStore, singleOrderStore } = getRootStore();
    const { details } = orderDetailStore;
    const canEdit = singleOrderStore.canEditOrder();
    const scheduledFormatted = details?.scheduledDate
        ? new Date(details.scheduledDate).toLocaleString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        })
        : "—";
    const vehicleSummary = details?.vehicle
        ? [
            details.vehicle.brand,
            details.vehicle.model,
            details.vehicle.stateNumber,
        ]
            .filter(Boolean)
            .join(" · ") || "—"
        : "—";
    const tariffDisplay = details?.tariffPerKwt != null
        ? `${details.tariffPerKwt} ₽/кВт·ч`
        : "—";
    const currentChargeDisplay = details?.liveCharging?.currentCharge != null
        ? `${details.liveCharging.currentCharge}%`
        : "—";
    return (_jsx(Card, { className: styles.card, size: "small", title: _jsxs("div", { className: styles.cardTitle, children: [_jsx(Text, { strong: true, children: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0437\u0430\u043A\u0430\u0437\u0430" }), canEdit && (_jsx(Button, { type: "link", size: "small", icon: _jsx(EditOutlined, {}), className: styles.editBtn, onClick: () => singleOrderStore.openEdit(), children: "\u0420\u0435\u0434." }))] }), children: _jsxs("div", { className: styles.rows, children: [_jsx(ParamRow, { label: "\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F", value: scheduledFormatted }), _jsx(ParamRow, { label: "\u0410\u0432\u0442\u043E", value: vehicleSummary }), details && !details.vehicle ? (
                /* D31б (WP-DSP-FIX-02): старый заказ без автомобиля — предупреждение, редактирование не блокируется */
                _jsx(Text, { type: "warning", className: styles.value, "data-testid": "orderdetail-vehicle-warning", children: "\u0423 \u0437\u0430\u043A\u0430\u0437\u0430 \u043D\u0435 \u0443\u043A\u0430\u0437\u0430\u043D \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u2014 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0439 \u043E\u043D \u043D\u0435 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F" })) : null, _jsx(ParamRow, { label: "\u0422\u0430\u0440\u0438\u0444", value: tariffDisplay }), _jsx(ParamRow, { label: "\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0437\u0430\u0440\u044F\u0434", value: currentChargeDisplay })] }) }));
});
OrderParamsCard.displayName = "OrderParamsCard";
export default OrderParamsCard;
